import script from "./WCProductPriceCardModern.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCProductPriceCardModern.vue?vue&type=script&setup=true&lang=ts"

import "./WCProductPriceCardModern.vue?vue&type=style&index=0&id=5ffdee08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ffdee08"]])

export default __exports__